import * as React from "react";
import { forwardRef } from "react";
const SvgTask = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0v17.477h17.477V5.962L16.02 7.418v8.6H1.456V1.456h14.428L17.34 0Zm16.953 2.389L8.738 10.6 5.621 7.487 4.574 8.534l3.641 3.641.523.5.523-.5L18 3.436Z", className: "sd2ff0803df04d63c2d12b6aa7724002f__b" }));
const ForwardRef = forwardRef(SvgTask);
export { ForwardRef as ReactComponent };
